import { RootState } from "../root.reducer";

export const contactInformationSelector = (state: RootState) =>
  state.contactInformation;
